import React from 'react'
import { Box, Typography } from '@mui/material'

const dashSx = (selected) => ({
  width: selected ? 10 : 8,
  height: selected ? 10 : 8,
  borderRadius: '50%',
  mr: 0.75,
  flexShrink: 0,
  transition: 'all 0.2s ease'
})

export function ColorDash({ color, selected, palette, originalIndex, selectedIndex }) {
  const resolvedColor =
    color != null ? color : palette[originalIndex % palette.length]
  const resolvedSelected =
    typeof selected === 'boolean' ? selected : selectedIndex === originalIndex

  return (
    <Box
      sx={{
        ...dashSx(resolvedSelected),
        backgroundColor: resolvedColor
      }}
    />
  )
}

const centerShellSx = {
  width: 52,
  height: 52,
  border: '2px solid rgba(69, 68, 89, 0.05)',
  borderRadius: '50%',
  backgroundColor: '#fff',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

export function CircleLabelNumber({ number, formatDisplay }) {
  const text = formatDisplay ? formatDisplay(number) : number

  return (
    <Box sx={centerShellSx}>
      <Typography sx={{ fontWeight: 700, fontSize: 19, color: '#111827' }}>{text}</Typography>
    </Box>
  )
}
